export default __webpack_public_path__ + "static/ship_compare_comp1_inactive-9f1c4e7009c9d5310d2e4e0ae0fbdce2.png";